<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <mtc-form-item label="label.languageName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['languageName']" :placeholder="$t('label.pleaseEnterlanguageName')"></a-input>
        </mtc-form-item>
        <mtc-form-item label="label.languageCode" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['languageCode']" :placeholder="$t('label.pleaseEnterlanguageCode')"></a-input>
        </mtc-form-item>
        <mtc-form-item label="tableHeader.sort" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['seq']" :placeholder="$t('label.pleaseEnterSort')"></a-input>
        </mtc-form-item>
        <mtc-form-item label="label.remarks" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['description']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
        </mtc-form-item>
        <!--        <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['createBy']" placeholder="请输入创建人"></a-input>
                </a-form-item>
                <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date placeholder="请选择创建时间" v-decorator="['createTime']" :trigger-change="true" style="width: 100%"/>
                </a-form-item>
                <a-form-item label="修改人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['updateBy']" placeholder="请输入修改人"></a-input>
                </a-form-item>
                <a-form-item label="修改时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <j-date placeholder="请选择修改时间" v-decorator="['updateTime']" :trigger-change="true" style="width: 100%"/>
                </a-form-item>
                <a-form-item label="所属部门编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['sysOrgCode']" placeholder="请输入所属部门编码"></a-input>
                </a-form-item>
                <a-form-item label="备注,后台用" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['notes']" placeholder="请输入备注,后台用"></a-input>
                </a-form-item>-->
        <!--        <a-form-item label="是否为主要语言" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-radio-group v-decorator="['mainLanguage', { initialValue: 'Y' }]">
                    <a-radio value="Y">是</a-radio>
                    <a-radio value="N">否</a-radio>
                  </a-radio-group>
                </a-form-item>-->
        <!--<mtc-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--&lt;!&ndash;          <a-input v-decorator="['validFlag']" placeholder="请输入是否有效，Y有效 N禁用"></a-input>&ndash;&gt;-->
        <!--<a-radio-group v-decorator="['validFlag', { initialValue: 'Y' }]" @change="validFlagChange">-->
        <!--<a-radio value="Y">是</a-radio>-->
        <!--<a-radio value="N">否</a-radio>-->
        <!--</a-radio-group>-->
        <!--</mtc-form-item>-->
        <mtc-form-item label="label.whetherValid" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['validFlag', {}]"
            :placeholder="$t('label.pleaseSelectWhetherSynchronizeWorkflowEngine')"
            :type="'radio'"
            :triggerChange="true"
            dictCode="valid_flag"
          />
        </mtc-form-item>
        <!-- <a-form-item label="是否为次要语言" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group :disabled="model.validFlag == 'N'" v-decorator="['secondLanguage', { initialValue: 'Y' }]">
            <a-radio value="Y">是</a-radio>
            <a-radio value="N">否</a-radio>
          </a-radio-group>
        </a-form-item> -->
        <!--        <a-form-item label="是否删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['delFlag']" placeholder="请输入是否删除，Y删除、N可用"></a-input>
                </a-form-item>-->
        <!--        <a-form-item label="租户信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['tenantCode']" placeholder="请输入租户信息"></a-input>
                </a-form-item>-->

      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDate from '@/components/jeecg/JDate'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysLanguageConfigurationModal',
  components: {
    JDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: `${MTC_AUTH}system/sysLanguageConfiguration/add`,
        edit: `${MTC_AUTH}system/sysLanguageConfiguration/edit`
      }
    }
  },
  created() {
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'languageName', 'languageCode', 'seq', 'description', 'createBy', 'createTime', 'updateBy', 'updateTime', 'sysOrgCode', 'notes', 'validFlag', 'delFlag', 'tenantCode', 'mainLanguage'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    validFlagChange(e) {
      this.model.validFlag = e.target.value
      // if (this.model.validFlag == 'N') {
      //   this.model.secondLanguage = 'N'
      // }
      this.form.setFieldsValue(pick(this.model, 'validFlag'))
      // this.form.setFieldsValue(pick(this.model,'validFlag','secondLanguage'))
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.close()
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }

      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'languageName', 'languageCode', 'seq', 'description', 'createBy', 'createTime', 'updateBy', 'updateTime', 'sysOrgCode', 'notes', 'validFlag', 'delFlag', 'tenantCode', 'mainLanguage'))
    }

  }
}
</script>